import { useContext } from "react";
import { UUID } from "crypto";
import { NawyPassportContext } from "@/modules/common/context/nawy-passport.provider";
import { userHasPermission } from "@/modules/common/utils";
import { PermissionLevel, PermissionsEnum } from "@/modules/common/types";
import PermissionGuard from "@/modules/common/components/wrappers/permission-guard";
import ResponsiveModal from "@/modules/common/components/ui-kit/modals/responsive-modal";
import EditCampaign from "@/modules/lead-page/components/lead-info/edit-fields/campaign";
import LeadInfoField from "@/modules/lead-page/new/components/lead-info-field";
import useLeadInfo from "@/modules/lead-page/hooks/lead-info/lead-info.hook";
import FieldWrapper from "@/modules/lead-page/new/components/sidebar/fields/field-wrapper";

const CampaignField = () => {
  const { campaign, isLoading, handleConfirmUpdate } = useLeadInfo();
  const { permissions: currentUserPermissions } =
    useContext(NawyPassportContext);

  return (
    <LeadInfoField
      editable={userHasPermission(
        {
          name: PermissionsEnum.EDIT_JOURNEY_CAMPAIGN_DETAILS,
          level: PermissionLevel.WRITE,
        },
        currentUserPermissions
      )}
      sxInnerBox={{
        justifyContent: "space-between",
      }}
      content={campaign.value || "Not Set"}
      setEditModalOpen={campaign.setEditCampaignModalOpen}
      editModalOpen={campaign.editCampaignModalOpen}
      editModal={
        <PermissionGuard
          permissions={[
            {
              name: PermissionsEnum.EDIT_JOURNEY_CAMPAIGN_DETAILS,
              level: PermissionLevel.WRITE,
            },
          ]}
        >
          <ResponsiveModal
            open={campaign.editCampaignModalOpen}
            onClose={() => {
              campaign.setEditCampaignModalOpen(false);
              campaign.setState(null);
            }}
            title="Edit Campaign"
            confirmButtonText="Save"
            cancelButtonText="Cancel"
            onConfirm={() => {
              handleConfirmUpdate({
                lead: {
                  campaignUId: campaign.state?.uid as UUID,
                },
              });
              campaign.setState(null);
            }}
            isLoading={isLoading}
            isConfirmDisabled={!campaign.state}
            snapPoints={[1]}
          >
            <FieldWrapper>
              <EditCampaign campaign={campaign} />
            </FieldWrapper>
          </ResponsiveModal>
        </PermissionGuard>
      }
    />
  );
};

export default CampaignField;
